import React, { useState, useEffect, useRef } from "react";
import {
  ProductImages,
  ProductImageSlider,
  ProductImagesList,
  ProductImageMain,
  ProductData,
} from "./style";
import CurrencyFormat from "../../utils/currencyFormat";
import useRouter from "../../hooks/useRouter";
import MainButton from "../../components/MainButton";
import MainModal from "../../components/MainModal";
import { ShippingModal } from "../../components/ShippingModal";
import QuantityCounter from "../../components/QuantityCounter";
import NotificationModal from "../../components/NotificationModal";
import AddFrom from "../../components/AddFrom";
import useView from "../../hooks/useView";
import CornerRibbon from "react-corner-ribbon";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { shouldShowMarcaBlancaModal } from "../../components/MarcaBlancaModal/shouldShow";
import config, { path } from "../../config/enviroment";
import {
  handleShopping,
  isSummaryPage,
  handleRefProductEdit,
} from "../../redux/actions/shoppingCartActions";
import { Share } from "../../components/share";
// @ts-ignore
import ReactImageZoom from "react-image-zoom";
import {
  calculatePriceWithTax,
  formatDate,
  formatErrorQuote,
  returnProduct,
  validateSelect,
  findNameRef,
} from "../../utils/formatData";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  handleToggleShippingModal,
  handleRequestQuote,
  handleLoadErrorQuote,
  handleResetQuote,
  handleToggleShowAlertSelectedCity,
  showMarcaBlancaCartLimit,
} from "../../redux/actions";
import AlertSelectCity from "../../components/AlertSelectCity";
import AveonlineLoginError from "../../components/AveonlineLoginError";
import { ReferenceOther, ReferenceColor, UnavailableProduct } from "./style";
import { render } from "@testing-library/react";
import { language } from "../../utils/language";
import { exceedsMarcaBlancaLimit, getCartUnits } from "../../utils/marcaBlancaCart";
import {
  getPhysicalCartSubtotal,
  getProductUnitPrice,
  isDigitalProduct,
} from "../../utils/cartSubtotal";
import { getFreeShippingStatus } from "../../utils/shippingRules";
import FreeShippingProgress from "../../components/FreeShippingProgress";

export const ProductImgContent = ({
  images,
  amount,
  discountRate,
  discountPrice,
  product,
  refSelect,
}: any) => {
  const [currentImage, setCurrentImage] = useState(images[0]);
  const { width, display } = useView();
  const props = { img: currentImage, zoomPosition: "original" };

  const [copyImages, setCopyImages] = useState<any>([]);

  useEffect(() => {
    if (validateSelect(refSelect, product) && refSelect !== null) {
      const imgReference = returnProduct(
        product,
        "img",
        findNameRef(refSelect)
      );
      if (
        imgReference !== "" &&
        imgReference !== null &&
        imgReference !== `${config.urlMultimedia}/null`
      ) {
        setCopyImages([...images, imgReference]);
        setCurrentImage(imgReference);
      } else {
        setCopyImages([...images]);
        setCurrentImage(images[0]);
      }
    } else {
      setCopyImages([...images]);
      setCurrentImage(images[0]);
    }
  }, [refSelect, images]);

  if (display !== "desktop") {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <ProductImageSlider currentWidth={width}>
        <Slider {...settings}>
          {copyImages.map((image: string) => (
            <ProductImageMain key={image}>
              <img src={image} alt={image} />
              {returnProduct(product, "discountRate") > 0 && (
                <CornerRibbon
                  backgroundColor="#ff0000"
                  fontColor="#f0f0f0"
                  containerStyle={{}}
                >
                  {!validateSelect(refSelect, product) && (
                    <AddFrom
                      product={product}
                      field={"discountRate"}
                      fontSize=".5rem"
                      fontWeight="600"
                      br={true}
                    />
                  )}
                  <span
                    style={{
                      fontFamily: "Roboto",
                      fontWeight: 700,
                      fontSize: "1.4em",
                    }}
                  >
                    {" " +
                      returnProduct(
                        product,
                        "discountRate",
                        findNameRef(refSelect)
                      )}
                    %off
                  </span>
                </CornerRibbon>
              )}
            </ProductImageMain>
          ))}
        </Slider>
      </ProductImageSlider>
    );
  } else {
    return (
      <ProductImages>
        {copyImages && copyImages.length > 1 ? (
          <>
            <ProductImagesList>
              {copyImages &&
                copyImages.map((image: string) => (
                  <img
                    src={image}
                    key={image}
                    alt={image}
                    onClick={() => {
                      setCurrentImage(image);
                    }}
                    className={
                      currentImage === image ? "selected-image" : "normal-image"
                    }
                  />
                ))}
            </ProductImagesList>
            <ProductImageMain>
              {/* <img src={currentImage} key={currentImage} alt={currentImage}/> */}
              <ReactImageZoom {...props}></ReactImageZoom>
              {returnProduct(product, "discountRate", findNameRef(refSelect)) >
              0 ? (
                <CornerRibbon
                  backgroundColor="#ff0000"
                  fontColor="#f0f0f0"
                  containerStyle={{}}
                >
                  {!validateSelect(refSelect, product) && (
                    <AddFrom
                      product={product}
                      field={"discountRate"}
                      fontSize=".6rem"
                      fontWeight="600"
                      br={true}
                    />
                  )}
                  <span
                    style={{
                      fontFamily: "Roboto",
                      fontWeight: 700,
                      fontSize: "1.4em",
                    }}
                  >
                    {" " +
                      returnProduct(
                        product,
                        "discountRate",
                        findNameRef(refSelect)
                      )}
                    %off
                  </span>
                </CornerRibbon>
              ) : null}
            </ProductImageMain>
          </>
        ) : copyImages.length === 1 ? (
          <ProductImageMain>
            <ReactImageZoom {...props}></ReactImageZoom>
            {returnProduct(product, "discountRate", findNameRef(refSelect)) >
            0 ? (
              <CornerRibbon
                backgroundColor="#ff0000"
                fontColor="#f0f0f0"
                containerStyle={{}}
              >
                {!validateSelect(refSelect, product) && (
                  <AddFrom
                    product={product}
                    field={"discountRate"}
                    fontSize=".6rem"
                    fontWeight="600"
                    br={true}
                  />
                )}
                <span
                  style={{
                    fontFamily: "Roboto",
                    fontWeight: 700,
                    fontSize: "1.4em",
                  }}
                >
                  {" " +
                    returnProduct(
                      product,
                      "discountRate",
                      findNameRef(refSelect)
                    )}
                  %off
                </span>
              </CornerRibbon>
            ) : null}
          </ProductImageMain>
        ) : (
          <div>No Image</div>
        )}
      </ProductImages>
    );
  }
};

export const ProductDataContent = ({
  product,
  color,
  idCatalog,
  shortUrl,
  codigo,
  resetOperator,
  setCodigo,
  refSelect,
  setRefSelect,
  availableReferences,
  refIdOptional,
}: any) => {
  const productState: any = useSelector((state: RootState) => state.product);
  const shoppingCart: any = useSelector(
    (state: RootState) => state.shoppingCart
  );
  const homeState: HomeStateType = useSelector(
    (state: RootState) => state.home
  );
  const elogisticaState: any = useSelector(
    (state: RootState) => state.elogistica
  );
  const aveonlineIntegration: any = useSelector(
    (state: RootState) => state.aveonline.integration
  );
  const isAveonlineStore = Boolean(
    aveonlineIntegration?.status &&
      aveonlineIntegration?.wherehouseStatus === "Confirmado"
  );
  const clientState: any = useSelector((state: RootState) => state.client);
  const marcaBlancaState: any = useSelector(
    (state: RootState) => state.marcaBlanca
  );
  const isMarcaBlancaStore = shouldShowMarcaBlancaModal(
    clientState?.id,
    config.marcaBlancaId
  );
  const marcaBlancaMaxUnits = marcaBlancaState.client?.maxDataphoneUnits ?? 0;
  const shopping = true;
  const { history } = useRouter();
  const [currentPosition, setCurrentPosition] = useState<string>("0");
  const [showModal, setShowModal] = useState(false);
  const [showAlertSelectedCity, setShowAlertSelectedCity] = useState(false);
  const [menssageError, setMenssageError] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [includeSelection, setIncludeSelection] = useState(true);

  useEffect(() => {
    setIncludeSelection(true);
  }, [product?.id]);
  const [refIdLocal, setRefIdLocal] = useState(null);
  const refData: any = useRef();
  const [amounts, setAmounts] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [errorValidateSelect, setErrorValidateSelect] =
    useState<boolean>(false);
  const [menssageErrorValidateSelect, setMenssageErrorValidateSelect] =
    useState<string>("");
  const [lastSelection, setLastSelection] = useState<any>({});
  const [showAveonlineLoginError, setShowAveonlineLoginError] = useState(false);

  useEffect(() => {
    if (
      elogisticaState.selectedCity.codigoDane !== 0 &&
      elogisticaState.requestQuote.length > 0 &&
      elogisticaState.selectedCity.codigoDane !== codigo &&
      codigo !== ""
    ) {
      let operator = elogisticaState.requestQuote[0].operador;
      setMenssageError("");
      dispatch(handleResetQuote());
      dispatch(handleLoadErrorQuote(""));
      requestQuote(operator);
    }
  }, [elogisticaState.selectedCity.codigoDane]);

  useEffect(() => {
    if (elogisticaState.errorQuote !== "") {
      setMenssageError(
        formatErrorQuote(elogisticaState.errorQuote, homeState.default_language)
      );
      refData.current.open();
    }
  }, [elogisticaState.errorQuote]);

  const requestQuote = (operator: string) => {
    if (homeState.epaycoDeliveryProvider && product.epaycoDeliveryProvider) {
      const payload = {
        operador: operator,
        id_configuracion: homeState.pickupConfigurationId,
        ciudad_destino: elogisticaState.selectedCity.codigoDane,
        valor_mercancia:
          Math.round(product.amount) === 0 ? 1 : Math.round(product.amount),
        fecha_cotizacion: formatDate(new Date()),
        envio: [
          {
            cantidad_unidades: quantity,
            peso_real:
              Math.round(product.realWeight) === 0
                ? 1
                : Math.round(product.realWeight),
            alto: product.high,
            largo: product.long,
            ancho: product.width,
          },
        ],
      };
      dispatch(handleRequestQuote(payload));
    }
  };

  const formatNameCity = (name: string) => {
    if (name !== "BOGOTÁ D.C.") {
      const arr = name.split(" ");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
      }
      const str2 = arr.join(" ");
      return str2;
    } else {
      return "Bogotá D.C.";
    }
  };

  const pushToSummary = () => {
    if (product.aveonlineId && aveonlineIntegration?.aveonlineLoginErrorStatus) {
      setShowAveonlineLoginError(true);
      return;
    }
    if (
      isMarcaBlancaStore &&
      exceedsMarcaBlancaLimit(shoppingCart.cartInfo, quantity, marcaBlancaMaxUnits)
    ) {
      dispatch(showMarcaBlancaCartLimit());
      return;
    }
    if (
      homeState.epaycoDeliveryProvider &&
      product.epaycoDeliveryProvider &&
      elogisticaState.requestQuote.length === 0
    ) {
      ref2.current.open();
    } else {
      if (validateSelect(refSelect, product)) {
        dispatch(handleResetQuote());
        dispatch(handleLoadErrorQuote(""));
        handleAddCart(`/vende/${homeState.catalogueUrlName}/carrito`);
        dispatch(isSummaryPage(true));
        // history.push(`/vende/${homeState.catalogueUrlName}/carrito/${shoppingCart.id}`)
      } else {
        setErrorValidateSelect(true);
        setMenssageErrorValidateSelect(
          language[homeState.default_language]["chooseReference"]
        );
        refData.current.open();
      }
    }
    dispatch(isSummaryPage(true));
    // history.push(`/vende/${homeState.catalogueUrlName}/carrito/${shoppingCart.id}`)
  };

  const handleAddCart = async (rediretPath: string | null = null) => {
    if (product.aveonlineId && aveonlineIntegration?.aveonlineLoginErrorStatus) {
      setShowAveonlineLoginError(true);
      return;
    }
    if (
      isMarcaBlancaStore &&
      exceedsMarcaBlancaLimit(shoppingCart.cartInfo, quantity, marcaBlancaMaxUnits)
    ) {
      dispatch(showMarcaBlancaCartLimit());
      return;
    }
    if (
      homeState.epaycoDeliveryProvider &&
      elogisticaState.requestQuote.length === 0 &&
      product.epaycoDeliveryProvider
    ) {
      dispatch(handleToggleShowAlertSelectedCity());
      ref2.current.open();
    } else {
      if (validateSelect(refSelect, product)) {
        let operator =
          elogisticaState.requestQuote.length !== 0 &&
          elogisticaState.requestQuote[0].operador !== "" &&
          elogisticaState.requestQuote[0].operador !== undefined
            ? elogisticaState.requestQuote[0].operador
            : operatorDefault();
        let valueDelivery =
          elogisticaState.requestQuote.length > 0
            ? elogisticaState.requestQuote[0].costo_total
            : 0;
        const amountAux = shoppingCart.id ? [...amounts] : [];
        let reference: any = {};
        let referenceId = null;
        const quantityCopy = quantity;
        if (refSelect !== null && product.references.length > 0) {
          let refName = findNameRef(refSelect);
          reference = product.references.find(
            (item: any) => item.name === refName
          );
          referenceId = reference.id;
          const item = {
            id: reference.id,
            quantity: quantityCopy,
          };
          amountAux.push(item);
          setAmounts([...amountAux]);
          setRefIdLocal(reference.id);
        }
        setShowModal(true);

        const successResponse = await (dispatch as any)(
          handleShopping(
            homeState.default_language,
            quantityCopy, // cantidad sin referencia
            valueDelivery, // valor del envio si aplica
            operator, // operadora seleccionada si aplica
            shoppingCart.id ? shoppingCart.id : null, // id del carrito
            path, // ruta enviada
            rediretPath,
            referenceId,
            product.id,
            history
          )
        );

        if (successResponse) {
          setIncludeSelection(false);
        }
        if (!successResponse) {
          setShowModal(false);
          setErrorValidateSelect(true);
          setMenssageErrorValidateSelect(
            language[homeState.default_language]["productUnavailable"]
          );
          refData.current.open();
        }
        dispatch(isSummaryPage(false));
        dispatch(handleResetQuote());
        dispatch(handleLoadErrorQuote(""));
      } else {
        setErrorValidateSelect(true);
        setMenssageErrorValidateSelect(
          language[homeState.default_language]["chooseReference"]
        );
        refData.current.open();
      }
    }
  };

  const operatorDefault = () => {
    return homeState.epaycoDeliveryProvider && product.epaycoDeliveryProvider
      ? "472"
      : "";
  };

  const ref: any = useRef();
  const ref2: any = useRef();

  useEffect(() => {
    const productsInCart: any = shoppingCart.cartInfo.filter(
      (productTemp: any) => productTemp.id === productState.productInfo.id
    );
    if (
      shoppingCart.id !== 0 &&
      productsInCart.length >= 1 &&
      productsInCart[0].references &&
      productsInCart[0].references.length > 0
    ) {
      setAmounts(productsInCart[0].references);
    } else {
      setQuantity(1);
      dispatch(handleRefProductEdit(null));
    }
  }, [shoppingCart.cartInfo]);

  const shoppingAction = (product: any) => {
    dispatch(handleToggleShippingModal(true));
    resetOperator("");
    ref.current.open();
  };

  const refSetState = (values: any) => {
    setRefSelect(values);
    dispatch(handleResetQuote());
    dispatch(handleLoadErrorQuote(""));
    resetOperator("");
    setQuantity(1);
    setIncludeSelection(true);
  };

  const handleSelectRef = (key: number, value: string) => {
    let values = [...refSelect];
    values[key] = value;
    setLastSelection({ key, value });

    let valuesNull = values.filter((item: any) => item === null);

    if (valuesNull.length === 0) {
      let refName = findNameRef(values);
      const reference = availableReferences.find(
        (item: any) => item.reference === refName
      );

      if (reference.available > 0) {
        refSetState(values);
      } else {
        values = refSelect.map((item: any) => null);
        values[key] = value;

        refSetState(values);
      }
    } else {
      refSetState(values);
    }
  };

  const parseAvailable = (data: any) => {
    const available = parseInt(data);
    return typeof available === "number" && !isNaN(available) ? available : 1;
  };

  const findAvailability = (type: string = "string") => {
    if (product.references.length > 0) {
      let refName = findNameRef(refSelect);
      const reference = product.references.find(
        (item: any) => item.name === refName
      );
      return type === "string"
        ? ` ${reference?.available}`
        : parseAvailable(reference?.available);
    } else {
      return type === "string"
        ? ` ${product?.available}`
        : parseAvailable(product?.available);
    }
  };

  const findAmountProduct = (field: string | null = "amount") => {
    if (product.references && product.references.length > 0) {
      let refName = findNameRef(refSelect);
      const reference = product.references.find(
        (item: any) => item.name === refName
      );
      if (field !== null && reference) {
        return reference?.[field];
      }
      return reference;
    }
    return field !== null ? product[field] : product;
  };

  const cartItems = shoppingCart.cartInfo || [];
  const countsSelection = includeSelection && !isDigitalProduct(product);
  const selectionAmount = countsSelection
    ? quantity * getProductUnitPrice(findAmountProduct(null))
    : 0;
  const hasPhysicalProducts =
    countsSelection ||
    cartItems.some((item: any) => !isDigitalProduct(item?.productData));
  const physicalCartAmount = getPhysicalCartSubtotal(cartItems);
  const cartFreeShippingStatus = getFreeShippingStatus(
    homeState.shippingType,
    homeState.freeShippingMinAmount,
    physicalCartAmount
  );
  const freeShippingStatus = {
    ...getFreeShippingStatus(
      homeState.shippingType,
      homeState.freeShippingMinAmount,
      physicalCartAmount + selectionAmount
    ),
    reached: cartFreeShippingStatus.reached,
  };

  const getColor = (data?: string) => {
    const label = data ? data.toLowerCase() : "";
    const colors: any = {
      blanco: "#FFFFFF",
      negro: "#000000",
      beige: "#FAF1DA",
      marrón: "#97661D",
      marron: "#97661D",
      amarillo: "#FFD100",
      azul: "#40A8E6",
      rojo: "#E1251B",
      verde: "#67C940",
      naranja: "#FF6720",
      morado: "#9000B4",
    };
    return colors[label] ? colors[label] : null;
  };

  const renderRefAux = (reference: any, itemReference: any, key: number) => {
    let availableItemReference = validateReference(itemReference);

    if (reference.type !== "color") {
      if (
        availableItemReference.length &&
        availableItemReference[0].available > 0
      ) {
        return (
          <ReferenceOther
            className="product-data-references-button"
            color={homeState.color}
            onClick={() => handleSelectRef(key, itemReference)}
            active={refSelect[key] === itemReference}
            key={itemReference}
          >
            {" "}
            {itemReference}{" "}
          </ReferenceOther>
        );
      }
    } else {
      let isInFeatures = availableItemReference.some((item: any) =>
        item.features.includes(itemReference)
      );

      if (availableItemReference.length && isInFeatures) {
        return (
          <ReferenceColor
            className="product-data-references-button"
            color={homeState.color}
            background={getColor(itemReference)}
            onClick={() => handleSelectRef(key, itemReference)}
            active={refSelect[key] === itemReference}
            key={itemReference}
          >
            {" "}
            {getColor(itemReference) ? "" : itemReference}{" "}
          </ReferenceColor>
        );
      }
    }
  };

  const validateReference = (itemReference: string) => {
    let availableItemReference = product.references
      .filter((item: any) => {
        let features = item.name.split("/");
        return features.includes(itemReference) && item.available > 0;
      })
      .map((values: any) => {
        return {
          features: values.name.split("/"),
          available: values.available,
        };
      });
    return availableItemReference;
  };

  const isTypeRef = (reference: any) => {
    let refSelectType = refSelect.find(
      (item: any) =>
        reference.values.find((value: any) => value === item) !== undefined
    );

    return refSelectType !== undefined;
  };

  const handlePositionRef = (itemReference: string) => {
    let index = product.setupReferences.findIndex(
      (item: any) =>
        item.values.find((value: any) => value === itemReference) !== undefined
    );

    return index;
  };

  const findRefSelect = (
    reference: any,
    itemReference: any,
    nameItem: any,
    key: number,
    boolReturn: boolean = false
  ) => {
    let availableItemReference = availableReferences.find((item: any) => {
      return item.reference === itemReference;
    });
    if (availableItemReference && availableItemReference.available > 0) {
      return !boolReturn ? renderRefAux(reference, nameItem, key) : true;
    } else {
      return !boolReturn ? <></> : false;
    }
  };

  const findRefSelectTwo = (
    missingKey: number,
    clonedRefSelect: any[],
    reference: any,
    itemReference: any,
    key: number
  ) => {
    let auxRefSelect = [...clonedRefSelect];
    return product.setupReferences[missingKey].values.find((item: string) => {
      auxRefSelect[missingKey] = item;
      let refName = findNameRef(auxRefSelect);
      return findRefSelect(reference, refName, itemReference, key, true);
    });
  };

  const handleRederSimulateSeleted = (
    itemReference: any,
    positionRefSeleted: number,
    key: number,
    reference: any
  ) => {
    const clonedRefSelect = [...refSelect];
    clonedRefSelect[key] = itemReference;
    let missingKey =
      key === 0 && positionRefSeleted === 1
        ? 2
        : key === 0 && positionRefSeleted === 2
        ? 1
        : 0;
    if (key === 1) {
      missingKey = positionRefSeleted === 0 ? 2 : 0;
    } else if (key === 2) {
      missingKey = positionRefSeleted === 1 ? 0 : 1;
    }
    let avalible = findRefSelectTwo(
      missingKey,
      clonedRefSelect,
      reference,
      itemReference,
      key
    );
    if (avalible) {
      return renderRefAux(reference, itemReference, key);
    } else {
      return <></>;
    }
  };

  const renderRef = (reference: any, itemReference: any, key: number) => {
    if (
      availableReferences !== null &&
      availableReferences.length > 0 &&
      availableReferences[0].features.length === 1
    ) {
      return findRefSelect(reference, itemReference, itemReference, key);
    } else {
      let filteredRefSelect = refSelect.filter((item: any) => item !== null);

      //VERIFY HERE
      if (
        filteredRefSelect.length === refSelect.length - 1 ||
        filteredRefSelect.length === refSelect.length
      ) {
        let typeRef = isTypeRef(reference);

        if (!typeRef || filteredRefSelect.length === refSelect.length) {
          const clonedRefSelect = [...refSelect];
          clonedRefSelect[key] = itemReference;

          let refName = findNameRef(clonedRefSelect);

          return findRefSelect(reference, refName, itemReference, key);
        } else {
          if (lastSelection.key === key) {
            const arrayRefSelected = refSelect.filter(
              (item: any) => item !== null
            );
            let itemReferenceSeleted = arrayRefSelected[0];
            let positionRefSeleted = handlePositionRef(itemReferenceSeleted);
            if (positionRefSeleted === key) {
              itemReferenceSeleted = arrayRefSelected[1];
            }
            positionRefSeleted = handlePositionRef(itemReferenceSeleted);
            if (refSelect.length === 3) {
              return handleRederSimulateSeleted(
                itemReference,
                positionRefSeleted,
                key,
                reference
              );
            }
            return renderRefAux(reference, itemReference, key);
          } else {
            return handleRederSimulateSeleted(
              itemReference,
              lastSelection.key,
              key,
              reference
            );
          }
        }
      } else if (
        filteredRefSelect.length === refSelect.length - 2 &&
        refSelect.length === 3
      ) {
        let typeRef = isTypeRef(reference);
        if (typeRef) {
          return renderRefAux(reference, itemReference, key);
        } else {
          let itemReferenceSeleted = refSelect.filter(
            (item: any) => item !== null
          )[0];
          let positionRefSeleted = handlePositionRef(itemReferenceSeleted);
          return handleRederSimulateSeleted(
            itemReference,
            positionRefSeleted,
            key,
            reference
          );
        }
      } else {
        return renderRefAux(reference, itemReference, key);
      }
    }
  };

  const stockAvailable =
    product.setupReferences &&
    refSelect &&
    product.setupReferences.length === refSelect.length
      ? findAvailability("number")
      : product.available;

  const quantityAvailable = isMarcaBlancaStore
    ? Math.max(
        0,
        Math.min(stockAvailable, marcaBlancaMaxUnits - getCartUnits(shoppingCart.cartInfo))
      )
    : stockAvailable;

  return (
    <ProductData>
      <MainModal
        show={showModal}
        color={color}
        product={product}
        showModal={showModal}
        setShowModal={setShowModal}
        quantity={quantity}
        refSelect={refSelect}
        refIdLocal={refIdLocal}
      ></MainModal>
      <div className="product-data-title">
        {product.title}
        <Share url={shortUrl} color={color} outlined={true} />
      </div>
      <div className="product-data-sales">
        <div></div>
        <div></div>
      </div>
      <div className="product-data-price">
        {returnProduct(product, "discountRate") > 0 && (
          <div className="product-data-discountPrice">
            <AddFrom
              product={product}
              field={"discountRate"}
              fontSize="1rem"
              fontWeight="400"
              br={false}
            />
            <CurrencyFormat
              amount={
                product.netAmount !== 0
                  ? calculatePriceWithTax(returnProduct(product))
                  : returnProduct(product, "amount")
              }
            />
          </div>
        )}
        <div className="product-data-mainPrice">
          <AddFrom
            product={product}
            field={"amount"}
            fontSize="2rem"
            fontWeight="400"
            br={false}
          />
          <b>
            <CurrencyFormat amount={returnProduct(product, "amount")} />
          </b>
        </div>
      </div>
      <div className="product-info">
        <div className="product-data-description">{product.description}</div>
        {product.setupReferences &&
          refSelect &&
          product.setupReferences.length === refSelect.length && (
            <div className="product-data-references">
              {product.setupReferences.map((references: any, key: number) => {
                return (
                  <>
                    <p>
                      <b>
                        {references.name}:{" "}
                        {refSelect !== null ? refSelect[key] : ""}
                      </b>
                    </p>
                    {references.values.map((itemReference: string) => {
                      return renderRef(references, itemReference, key);
                    })}
                  </>
                );
              })}
            </div>
          )}
        <div className="product-data-quantity">
          <p>{language[homeState.default_language]["amount"]}:</p>
          <QuantityCounter
            value={quantity}
            setValue={(value: number) => {
              dispatch(handleResetQuote());
              dispatch(handleLoadErrorQuote(""));
              resetOperator("");
              setQuantity(value);
              setIncludeSelection(true);
            }}
            available={quantityAvailable}
            color={color}
          />
          {product.showInventory &&
            ((refSelect !== null &&
              refSelect.find((item: any) => item === null) === undefined) ||
              product.references.length === 0) && (
              <span className="product-data-quantity-availability">
                {findAvailability()}{" "}
                {language[homeState.default_language]["productsAvailable"]}{" "}
              </span>
            )}
        </div>
        {!isAveonlineStore && hasPhysicalProducts && (
          <FreeShippingProgress
            variant="product"
            status={freeShippingStatus}
            color={color}
          />
        )}
        {homeState.epaycoDeliveryProvider && product.epaycoDeliveryProvider && (
          <div className="product-data-pickup">
            <p>
              {language[homeState.default_language]["send"]} :&nbsp;
              {elogisticaState.requestQuote.length == 0 ? (
                <>
                  <span>
                    {language[homeState.default_language]["calculateShipping"]}{" "}
                  </span>
                </>
              ) : homeState.freeDelivery ? (
                <span>{language[homeState.default_language]["free"]} </span>
              ) : (
                <>
                  <span>
                    <CurrencyFormat
                      amount={elogisticaState.requestQuote[0].costo_total}
                    />
                  </span>
                </>
              )}
            </p>
            {elogisticaState.requestQuote.length > 0 ? (
              <>
                <p
                  onClick={() => shoppingAction(product)}
                  style={{
                    fontFamily: "Open Sans",
                    fontSize: "0.83em",
                    color: "#23272b",
                    cursor: "pointer",
                  }}
                >
                  {language[homeState.default_language]["sendTo"]}{" "}
                  {formatNameCity(elogisticaState.selectedCity.nombre)} por{" "}
                  {elogisticaState.requestQuote[0].operador.toUpperCase()}
                  <ArrowDropDownIcon
                    style={{
                      color: "#000",
                      width: "13px",
                      marginTop: "-7px",
                      marginLeft: "-1px",
                    }}
                    viewBox="0 0 24 24"
                  />
                </p>
              </>
            ) : (
              <>
                <h5 onClick={() => shoppingAction(product)}>
                  {language[homeState.default_language]["selectDeliveryCity"]}:
                  <ArrowDropDownIcon
                    style={{
                      color: "#000",
                      width: "13px",
                      marginTop: "-7px",
                      marginLeft: "-1px",
                    }}
                    viewBox="0 0 24 24"
                  />
                </h5>
                <AlertSelectCity
                  show={showAlertSelectedCity}
                  color={homeState.color}
                  refData={ref2}
                />
              </>
            )}
          </div>
        )}
        <div className="product-data-totalPrice">
          <div className="mt-2">
            <ShippingModal
              product={product}
              color={homeState.color}
              refData={ref}
              quantity={quantity}
              codigo={codigo}
              setCodigo={setCodigo}
            />
          </div>
          {validateSelect(refSelect, product) ? (
            <>
              <div className="product-data-totalText">
                {language[homeState.default_language]["totalToPay"]}:
              </div>
              {findAmountProduct("discountRate") > 0 && (
                <div className="product-data-discountPrice">
                  <CurrencyFormat
                    amount={calculatePriceWithTax(
                      returnProduct(findAmountProduct(null))
                    )}
                  />
                </div>
              )}
              <div className="product-data-totalAmount">
                {<CurrencyFormat amount={quantity * findAmountProduct()} />}
              </div>
              {product.available ? (
                <div className="mt-2 product-data-buttons">
                  <MainButton
                    color={color}
                    secondary={false}
                    disabled={homeState.manage === 1 ? true : false}
                    onClick={pushToSummary}
                  >
                    {" "}
                    {language[homeState.default_language]["buyNow"]}{" "}
                  </MainButton>
                  <MainButton
                    color={color}
                    secondary={true}
                    disabled={homeState.manage === 1 ? true : false}
                    className="ml-2"
                    onClick={() => {
                      handleAddCart();
                    }}
                  >
                    {language[homeState.default_language]["addToCart"]}
                  </MainButton>
                </div>
              ) : (
                <UnavailableProduct className="unavailable-product">
                  <span>No disponible</span>
                </UnavailableProduct>
              )}
            </>
          ) : (
            <>
              {product.available ? (
                <div className="mt-2 product-data-buttons">
                  <MainButton
                    color={color}
                    secondary={false}
                    onClick={pushToSummary}
                  >
                    {language[homeState.default_language]["buyNow"]}{" "}
                  </MainButton>
                  <MainButton
                    color={color}
                    secondary={true}
                    className="ml-2"
                    onClick={() => {
                      handleAddCart();
                    }}
                  >
                    {language[homeState.default_language]["addToCart"]}
                  </MainButton>
                </div>
              ) : (
                <UnavailableProduct className="unavailable-product">
                  <span>No disponible</span>
                </UnavailableProduct>
              )}
            </>
          )}
        </div>
      </div>

      <NotificationModal
        refData={refData}
        message={
          errorValidateSelect ? menssageErrorValidateSelect : menssageError
        }
        positionAbsolute={errorValidateSelect}
        center={errorValidateSelect ? "center" : "none"}
        textBtn={
          errorValidateSelect
            ? language[homeState.default_language]["accept"]
            : language[homeState.default_language]["agree"]
        }
      />
      <AveonlineLoginError
        isOpen={showAveonlineLoginError}
        onClose={() => setShowAveonlineLoginError(false)}
        homeState={homeState}
      />
    </ProductData>
  );
};
